import React from "react";
import { IoCartOutline } from "react-icons/io5";
import styled from "styled-components";

const Empty = () => {
  return (
    <Wrapper>
      <IoCartOutline size={34} />
      <p>Your cart is empty.</p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 5rem 10rem;
  text-align: center;
  color: #979797;
  p {
    color: #060606;
  }
`;

export default Empty;
